module.exports = __webpack_public_path__ + "img/50_42.a535a4da.png";